import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  \n  ", "\n  ", "\n  ", "\n  \n  &:hover {\n    ", "\n  }\n  &:active {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, INACTIVE_GRAY, NIGHTINGALE_BLACK, SENSATION_WHITE } from '../colors';
import { SHADOW_FOCUSED } from '../shadows';
import { IconCircle, IconSquare } from '../SvgIcon';
import { BUTTON_MEDIUM_NEGATIVE_MARGIN_FULL_WIDTH, BUTTON_MEDIUM_PADDING_FULL_WIDTH, BUTTON_SMALL_NEGATIVE_MARGIN_FULL_WIDTH, BUTTON_SMALL_PADDING_FULL_WIDTH } from './constants';
import ButtonBaseWithContent from './components/ButtonBaseWithContent';
import { useDeviceType } from '../hooks';
import { Button as ButtonTypographySize } from '../Typography/constants/button.size';
import { ButtonSmall as ButtonSmallTypographySize } from '../Typography/constants/button-small.size';
import { buttonTypographyStyle } from '../Typography/style/button';
import { buttonBorderRadiusStyle } from './style/border-radius';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
import { padding } from '../style/padding';
import { margin } from '../style/margin';
var FONT_SIZE = {
  medium: ButtonTypographySize.fontSize,
  small: ButtonSmallTypographySize.fontSize
};
var LINE_HEIGHT = {
  medium: ButtonTypographySize.lineHeight,
  small: ButtonSmallTypographySize.lineHeight
};
var PADDING = {
  small: BUTTON_SMALL_PADDING_FULL_WIDTH,
  medium: BUTTON_MEDIUM_PADDING_FULL_WIDTH
};
var MARGIN = {
  small: BUTTON_SMALL_NEGATIVE_MARGIN_FULL_WIDTH,
  medium: BUTTON_MEDIUM_NEGATIVE_MARGIN_FULL_WIDTH
};
var StyledButtonBaseWithContent = styled(ButtonBaseWithContent)(_templateObject(), buttonTypographyStyle, function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  return fontSize(FONT_SIZE[size] || FONT_SIZE.medium);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size;
  return lineHeight(LINE_HEIGHT[size] || LINE_HEIGHT.medium);
}, buttonBorderRadiusStyle, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'medium' : _ref3$size;
  return padding(PADDING[size] || PADDING.medium);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'medium' : _ref4$size;
  return margin(MARGIN[size] || MARGIN.medium);
}, function (_ref5) {
  var disabled = _ref5.disabled,
      inactive = _ref5.inactive,
      $hasTouch = _ref5.$hasTouch;
  return !disabled && !inactive && !$hasTouch && "\n      & " + IconCircle + " {\n        box-shadow: " + SHADOW_FOCUSED + ";\n      }\n      & " + IconSquare + " {\n        box-shadow: " + SHADOW_FOCUSED + ";\n      }\n    ";
}, function (_ref6) {
  var disabled = _ref6.disabled,
      inactive = _ref6.inactive;
  return !disabled && !inactive && "\n      & " + IconCircle + " {\n        box-shadow: " + SHADOW_FOCUSED + ";\n      }\n      & " + IconSquare + " {\n        box-shadow: " + SHADOW_FOCUSED + ";\n      }\n    ";
});
var COLOR = {
  primary: NIGHTINGALE_BLACK,
  ghost: NIGHTINGALE_BLACK,
  inverse: SENSATION_WHITE,
  secondary: ADVENTURE_GREEN
};
var HOVER_COLOR = {
  primary: ADVENTURE_GREEN,
  ghost: NIGHTINGALE_BLACK,
  inverse: ADVENTURE_GREEN,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var ACTIVE_COLOR = {
  primary: ADVENTURE_GREEN_FOCUSED,
  ghost: NIGHTINGALE_BLACK,
  inverse: ADVENTURE_GREEN_FOCUSED,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var FOCUS_COLOR = {
  primary: ADVENTURE_GREEN_FOCUSED,
  ghost: ADVENTURE_GREEN_FOCUSED,
  inverse: ADVENTURE_GREEN_FOCUSED,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var ICON_COLOR = {
  primary: ELEMENT_GRAY,
  ghost: ELEMENT_GRAY,
  inverse: SENSATION_WHITE,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var ICON_HOVER_COLOR = {
  primary: ADVENTURE_GREEN,
  ghost: ELEMENT_GRAY,
  inverse: ADVENTURE_GREEN,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var ICON_ACTIVE_COLOR = {
  primary: ADVENTURE_GREEN_FOCUSED,
  ghost: INACTIVE_GRAY,
  inverse: ADVENTURE_GREEN_FOCUSED,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var ICON_FOCUS_COLOR = {
  primary: ADVENTURE_GREEN_FOCUSED,
  ghost: ADVENTURE_GREEN_FOCUSED,
  inverse: ADVENTURE_GREEN_FOCUSED,
  secondary: ADVENTURE_GREEN_FOCUSED
};
var TextButton = /*#__PURE__*/React.forwardRef(function (_ref7, forwardedRef) {
  var as = _ref7.as,
      forwardedAs = _ref7.forwardedAs,
      _ref7$iconMarginVaria = _ref7.iconMarginVariant,
      iconMarginVariant = _ref7$iconMarginVaria === void 0 ? 'medium' : _ref7$iconMarginVaria,
      _ref7$inverse = _ref7.inverse,
      inverse = _ref7$inverse === void 0 ? false : _ref7$inverse,
      _ref7$variant = _ref7.variant,
      variantProps = _ref7$variant === void 0 ? 'primary' : _ref7$variant,
      props = _objectWithoutPropertiesLoose(_ref7, ["as", "forwardedAs", "iconMarginVariant", "inverse", "variant"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var variant = useMemo(function () {
    return inverse ? 'inverse' : variantProps;
  }, [inverse, variantProps]);
  var iconMargin = useMemo(function () {
    return 8 + (iconMarginVariant === 'large' ? 4 : 0);
  }, [iconMarginVariant]);
  var iconRightMargin = useMemo(function () {
    return 4 + (iconMarginVariant === 'large' ? 4 : 0);
  }, [iconMarginVariant]);
  return /*#__PURE__*/React.createElement(StyledButtonBaseWithContent, _extends({
    ref: forwardedRef,
    forwardedAs: as != null ? as : forwardedAs,
    $hasTouch: hasTouchScreen,
    noIconWrapper: true,
    noShadow: true,
    noShadowActive: true,
    noShadowHover: true,
    noShadowFocus: true,
    noShadowDisabled: true,
    color: COLOR[variant] || COLOR.primary,
    hoverColor: HOVER_COLOR[variant] || HOVER_COLOR.primary,
    activeColor: ACTIVE_COLOR[variant] || ACTIVE_COLOR.primary,
    focusColor: FOCUS_COLOR[variant] || FOCUS_COLOR.primary,
    disabledColor: ELEMENT_GRAY,
    iconColor: ICON_COLOR[variant] || ICON_COLOR.primary,
    hoverIconColor: ICON_HOVER_COLOR[variant] || ICON_HOVER_COLOR.primary,
    activeIconColor: ICON_ACTIVE_COLOR[variant] || ICON_ACTIVE_COLOR.primary,
    focusIconColor: ICON_FOCUS_COLOR[variant] || ICON_FOCUS_COLOR.primary,
    disabledIconColor: ELEMENT_GRAY,
    borderColor: "transparent",
    activeBorderColor: "transparent",
    hoverBorderColor: "transparent",
    focusBorderColor: "transparent",
    disabledBorderColor: "transparent",
    backgroundColor: "transparent",
    activeBackgroundColor: "transparent",
    hoverBackgroundColor: "transparent",
    disabledBackgroundColor: "transparent",
    focusBackgroundColor: "transparent",
    iconMargin: iconMargin,
    iconRightMargin: iconRightMargin
  }, props));
});
export default TextButton;